import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SelectCustomEvent} from '@ionic/angular';
import {TipoRisorsa} from '../../../_models/generated/tipo-risorsa';
import {MetaService} from "../../../_services/meta.service";
import {map} from "rxjs";
import {formatLabel} from "../../../_helpers/label-utils";
import {TIPO_RISORSA_UI} from "../../../_helpers/TipoRisorsa";

@Component({
  selector: 'app-select-risorse-type',
  templateUrl: './select-risorse-type.component.html',
  styleUrls: ['./select-risorse-type.component.scss'],
  standalone: false
})
export class SelectRisorseTypeComponent {
  @Input() tipoRisorsa: TipoRisorsa = TipoRisorsa.TUTTO;
  @Output() tipoRisorsaChange = new EventEmitter<TipoRisorsa>();

  // Enum disponibile per l'uso nel template o in altre parti del codice
  TipoRisorsa = TipoRisorsa;

  // Observable per il template (compatibilità con select)
  // Utilizziamo i metadati dal backend con override UI locali
  tipiRisorses$ = this.metaService.getEnumOptions('TipoRisorsa', TIPO_RISORSA_UI).pipe(
    map(options => options.map(o => ({
      ...o,
      label: formatLabel(o.label)
    })))
  );

  constructor(private metaService: MetaService) { }


  selectTipoRisorsa = (e: SelectCustomEvent) => this.tipoRisorsaChange.emit(+e.detail.value as TipoRisorsa);
}
